<template>
  <div>
    <div class="content">
      <Steps :active="active" :stepsData="stepsData" :mode="mode" />
      <!-- 选择平台 -->
      <div v-if="active === 0" class="select-shops">
        <section>
          <span>1、选择平台</span>
          <div class="platforms">
            <a
              class="item"
              v-for="(item, idx) in platforms"
              :key="idx"
              @click="getShops(item.key)"
              :class="{ 'onshelf-selected-platform': source === item.key, 'platform-disabled': disablePlatForms.includes(item.key) }"
            >
              <img :src="item.icon" />
              <span>{{ item.name }}</span>
            </a>
          </div>
        </section>
        <section>
          <span>2、选择已授权店铺</span>
          <div class="shop-wrp">
            <div class="search-wrp">
              <el-input-popup-editor
                v-model="searchText"
                title="请输入店铺简称/名称"
                placeholder="请输入店铺简称/名称"
                topHint="多个店铺简称/名称，以逗号分隔或每行一个店铺简称/名称"
                :autosize="{ minRows: 6, maxRows: 10 }"
                width="220px"
                style="margin-right: 10px"
                @keyup.enter.native="search"
              ></el-input-popup-editor>
              <el-button @click="search">搜索</el-button>
              <el-button type="default" @click="reset">重置</el-button>
            </div>
            <div v-if="source && (shopList.length)" style="margin: 10px 0px;">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{ checkAll ? '取消全选' : '全选' }}</el-checkbox>
              <span style="color: red; margin-left: 10px;">注：全量勾选，可能导致铺货缓慢，请耐心等待</span>
            </div>
            <el-checkbox-group v-model="selectShops" style="margin-top: 8px">
              <el-checkbox v-for="item in shopList" :label="item.shopId" :key="item.shopId" style="margin: 0 10px 10px 0">
                <el-image v-if="item.icon" style="height: 16px; vertical-align: middle;" :src="item.icon"></el-image>
                {{ item.shortTitle || item.title }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </section>
      </div>
      <!-- 设置主商品 -->
      <div v-else-if="active === 1">
        <div class="prod-list">
          <div class="prod" v-for="(item, idx) in rowsData" :key="idx">
            <div class="descrip">
              <img :src="item.mainImagesTrim[0]" alt="error" />
              <p class="title">
                <span>{{ item.title }}</span>
                <span class="gray">款式编码：{{ item.outerId || item.outerItemId }}</span>
              </p>
              <span v-if="idx === mainProd" class="main-prod-tip">主商品</span>
            </div>
            <div>
              <el-button @click="setMainProd(idx)" type="link" v-if="idx !== mainProd">设为主商品</el-button>
              <el-button @click="setSpecValue(item)" type="link">设置规格值前缀/后缀</el-button>
            </div>
          </div>
        </div>
        <span class="gray">提醒：设置主商品后，组合铺货时款纬度的资料会以主商品为准。</span>
      </div>
      <!-- 选择规格 -->
      <div v-else>
        <SpecList ref="specList" :rowsData="rowsData" :mainProd="mainProd" :source="source" />
      </div>
    </div>
    <div class="shelf-dialog-footer">
      <span style="float: left"
        >已选择<el-link>{{ shopNum }}</el-link
        >家店铺</span
      >
      <div style="float: right">
        <template v-if="active === 0">
          <el-button @click="handleCancel">取 消</el-button>
          <el-button type="primary" @click="next(1)" :disabled="!shopNum">下一步</el-button>
        </template>
        <template v-else-if="active === 1">
          <el-button @click="pre(0)">上一步</el-button>
          <el-button type="primary" @click="next(2)">下一步</el-button>
        </template>
        <template v-else>
          <el-button @click="pre(1)">上一步</el-button>
          <el-button type="primary" @click="goPuhuo">去铺货</el-button>
        </template>
      </div>
    </div>
    <PddInfoFormDialog ref="pddInfoFormDialog" :closeStepsDialog="handleClose" />
    <!-- <PuhuoDialog ref="puhuoDialog" /> -->

    <el-dialog :visible.sync="pddAuthorizeVisible" title="拼多多店铺授权">
      <div>
        以下拼多多店铺授权已过期，点击链接
        <a :href="pddAuthorizeResult.length ? pddAuthorizeResult[0].authUrl : ''" target="_blank">去授权</a>
        <div v-for="shop in pddAuthorizeResult" :key="shop.shopId">
          <div v-if="!shop.tokenValid" class="mgt12">
            {{ shop.shopName }}
          </div>
        </div>
      </div>
    </el-dialog>
    <SetSpecValueDialog ref="setSpecValueDialogRef" />
  </div>
</template>

<script>
import { PUHUO_PLATFORMS_MAP } from '@/dictionary/platforms';

import { getShopList } from '@servers/base/shop/index.js';
import Steps from './components/steps.vue';
import SpecList from './components/specList.vue';
import PddInfoFormDialog from './components/pddInfoFormDialog.vue';
import SetSpecValueDialog from './components/setSpecValueDialog.vue';
// import PuhuoDialog from './puhuoDialog.vue';
import { mapGetters, mapActions } from 'vuex';
import { getPddShopAuthStatus } from '@/api/base';
import _ from 'lodash';

export default {
  components: {
    Steps,
    SpecList,
    PddInfoFormDialog,
    // PuhuoDialog,
    SetSpecValueDialog,
  },
  props: {
    mode: {
      type: String,
      default: '',
    },
    from: String,
    supplierCompanyId: [String, Number],
  },
  provide() {
    return {
      from: this.from,
      supplierCompanyId: this.supplierCompanyId,
      isGroupPuhuo: true
    };
  },
  data() {
    return {
      visible: false,
      rowsData: [],
      platforms: [],
      selectShops: [],
      source: '',
      shops: {},
      shopList: [],
      active: 0,
      searchText: '',
      checkAll: false,
      isIndeterminate: false,
      stepsData: [
        { label: '选择平台和店铺', edited: false },
        { label: '设置主商品', edited: false },
        { label: '选择规格', edited: false },
      ],
      mainProd: 0,
      pddAuthorizeVisible: false,
      pddAuthorizeResult: [],
      onSuccess: null,
      clearCart: false
    };
  },
  computed: {
    ...mapGetters(['prodRePublishRowData']),
    shopNum: function () {
      return this.selectShops.length;
    },
    allowPlatForms() {
      return ['pdd', 'fxg', 'kuaishou', '1688', 'jd', 'wxxd','xhs', 'tb', 'wxsph'];
    },
    disablePlatForms() {
      return [];
    },
  },
  watch: {
    selectShops: {
      handler(val) {
        if (this.shopList.length) {
          const shopIds = this.shopList.map(item => item.shopId);
          const isSame = val.length === shopIds.length && shopIds.every(id => val.includes(id));
          this.checkAll = isSame;
          this.isIndeterminate = val.length > 0 && !isSame;
        } else {
          this.checkAll = false;
          this.isIndeterminate = false;
        }
      },
      immediate: true,
    },
    visible() {
      this.$emit('visibleChange', this.visible);
    },
  },
  methods: {
    ...mapActions(['clearRePublishRowData']),
    async validPddShopAuth() {
      // pdd铺货需要判断店铺是否授权
      let shopIds = this.shopList.map(item => {
        if (this.selectShops.includes(item.shopId)) {
          return +item.taobaoId;
        }
        return null;
      });
      shopIds = shopIds.filter(Boolean);
      let res = await getPddShopAuthStatus({
        shopIds,
      });
      let data = (this.pddAuthorizeResult = _.get(res, 'data', []));
      let flag = data.every(item => {
        return item.tokenValid;
      });
      // 有过期店铺的就弹窗
      if (!flag) {
        this.pddAuthorizeVisible = true;
        return false;
      } else {
        return true;
      }
    },
    async next(activeNum) {
      let pass = true;
      if (activeNum === 1) {
        // 选择完店铺后需要校验pdd店铺有没有过期
        if (this.source === 'pdd') {
          pass = await this.validPddShopAuth();
        }
      }

      if (pass) {
        this.active = activeNum;
        this.stepsData[activeNum - 1].edited = true;
      }
    },
    pre(activeNum) {
      this.active = activeNum;
      this.stepsData[activeNum].edited = false;
    },
    handleClose() {
      this.visible = false;
      this.active = 0;
      (this.stepsData = [
        { label: '选择平台和店铺', edited: false },
        { label: '设置主商品', edited: false },
        { label: '选择规格', edited: false },
      ]),
        (this.mainProd = 0);
      this.selectShops = [];
      this.searchText = '';
      this.clearRePublishRowData();
    },
    handleCancel() {
      this.visible = false;
      this.clearRePublishRowData();
    },
    handleCheckAllChange(val) {
      this.selectShops = val ? this.shopList.map(item => item.shopId) : [];
    },
    method_open(data, clearCart, onSuccess) {
      this.rowsData = data;
      this.onSuccess = onSuccess;
      this.clearCart = !!clearCart;
      this.platforms = PUHUO_PLATFORMS_MAP.filter(item => this.allowPlatForms.includes(item.key));
      this.visible = true;
      this.source = '';
      this.selectShops = [];
      this.shopList = [];
      this.shops = {};
      if (this.prodRePublishRowData && this.prodRePublishRowData.publishEntrance == 0 && this.prodRePublishRowData.publishType == 2) {
        this.getShops(this.prodRePublishRowData.platform);
        const index = data.findIndex(item => item.baseItemId == this.prodRePublishRowData.baseItemId);
        this.mainProd = index == -1 ? 0 : index;
      }
    },
    search() {
      if (this.shops[this.source]?.length) {
        let shopList = []
        const shopAllList = this.shops[this.source]
        const queryShopName = (this.searchText || '').trim()
        if(!queryShopName){
          shopList = shopAllList
        } else{
          // 支持英文逗号、汉字逗号 分隔多个店铺名称
          const keywords = queryShopName.split(/[,，]+/).map(k => k.trim()).filter(Boolean)
          shopList = shopAllList.filter(item => {
            if (keywords.length === 1) {
              // 单个关键词时支持模糊搜索
              const kw = keywords[0]
              return item.shortTitle?.includes(kw) || item.title?.includes(kw)
            }
            return keywords.some(kw => item.shortTitle === kw || item.title === kw)
          })
        }
        this.shopList = shopList
      }
    },
    reset() {
      this.shopList = this.shops[this.source] || [];
      this.searchText = '';
    },
    async getShops(source) {
      this.source = source;
      if (this.prodRePublishRowData && this.prodRePublishRowData) {
        this.selectShops = [this.prodRePublishRowData.shopId];
      } else {
        this.selectShops = [];
      }
      if (this.shops[source]) {
        this.shopList = this.shops[source];
        return;
      }
      let _params = {};
      if (source == 'tjb') {
        _params = {
          source: 'tb',
          subSource: source,
          pageNo: 1,
          pageSize: 300,
        };
      } else {
        _params = {
          source: source,
          pageNo: 1,
          pageSize: 300,
        };
      }
      const res = await getShopList(_params, { isNeedLoading: false });
      if (res && res.list) {
        this.shopList = res.list
          .filter(item => item.state === 2 || item.state === 3)
          .map(item => {
            return {
              ...item,
              shopId: item.id,
              shopName: item.title,
              name: item.title,
            };
          });
        if (!this.shopList.length) {
          this.$message.warning('没有店铺或者店铺没有授权！');
        }
        if (this.shopList.length) {
          this.shops[source] = this.shopList.slice(0);
        }
      }
    },
    setMainProd(idx) {
      this.mainProd = idx;
    },
    setSpecValue(item) {
      const specNames = item.specifications.map(spec => {
        return {
          name: spec.name,
          nameKey: spec.nameKey,
        }
      });
      this.$refs.setSpecValueDialogRef.method_open({
        baseItemId: item.baseItemId || item.itemId,
        specNames,
        okFn: (data) => {
          item.skuSpecPrefixSuffixList = data;
        }
      })
    },
    goPuhuo() {
      const specList = this.$refs.specList.getSpecList();
      if (!specList.length) {
        this.$message.warning('请选择商品规格！');
        return;
      }
      const isValid = this.$refs.specList.validateSpecs();
      if (isValid) {
        this.$message.warning('请正确填写规格值！');
        return;
      };
      const shops = this.shops[this.source].filter(s => {
        if (this.selectShops.includes(s.shopId)) {
          return true;
        }
        return false;
      });
      const specNum = this.$refs.specList.getSpecNum();
      const extraParams = {
        onSuccess: this.onSuccess,
        clearCart: this.clearCart 
      };
      this.visible = false;
      this.$emit('openPuhuoDialog',{
        source: this.source,
        specNum,
        specList,
        formData: this.rowsData[this.mainProd],
        shops,
        rowsData: this.rowsData,
        closeFun: () => {
          this.visible = false;
        },
        ...extraParams,
      })
      // this.$refs.puhuoDialog.method_open({
      //   source: this.source,
      //   specNum,
      //   specList,
      //   formData: this.rowsData[this.mainProd],
      //   shops,
      //   rowsData: this.rowsData,
      //   closeFun: () => {
      //     this.visible = false;
      //   },
      //   ...extraParams,
      // });
        
      // if (this.source === 'pdd') {
      //   this.$refs.pddInfoFormDialog.method_open({
      //     specNum,
      //     specList,
      //     formData: this.rowsData[this.mainProd],
      //     shops,
      //     rowsData: this.rowsData,
      //     closeFun: () => {
      //       this.visible = false;
      //     },
      //   });
      // } else {
      //   this.$refs.puhuoDialog.method_open({
      //     source: this.source,
      //     specNum,
      //     specList,
      //     formData: this.rowsData[this.mainProd],
      //     shops,
      //     rowsData: this.rowsData,
      //     closeFun: () => {
      //       this.visible = false;
      //     },
      //   });
      // }
    },
    async sure() {},
  },
};
</script>

<style lang="scss" scoped>
.content {
  font-size: 12px;
  max-height: 600px;
  overflow: auto;
  .platform-disabled {
    pointer-events: none;
    opacity: 0.6;
  }
  .platforms {
    display: flex;
    flex-direction: row;
    padding: 15px;
    .item {
      display: flex;
      flex-direction: column;
      margin-right: 15px;
      cursor: pointer;
      text-decoration: none;
      color: #2c3e50;
      text-align: center;
      align-items: center;
      padding: 5px 8px;
      &.onshelf-selected-platform {
        border: 1px solid #2695fa;
        border-radius: 5px;
      }
      img {
        width: 40px;
        height: 40px;
        margin-bottom: 10px;
      }
    }
  }
  .search-wrp {
    margin-top: 10px;
  }
  .gray {
    color: #b9b8b8;
  }
  .prod-list {
    max-height: 360px;
    overflow-y: auto;
    margin-bottom: 18px;
    .prod {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ebebeb;
      align-items: center;
      padding: 10px;
      .descrip {
        display: flex;
        position: relative;
        .main-prod-tip {
          position: absolute;
          background: red;
          color: white;
          padding: 2px 10px;
          border-radius: 15px;
          transform: scale(0.83);
          font-weight: 500;
          left: -10px;
          top: -6px;
        }
      }
      .title {
        padding: 0;
        margin: 0;
        padding-top: 6px;
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        span:first-child {
          margin-bottom: 5px;
        }
      }
    }
    img {
      width: 56px;
      height: 55px;
    }
  }
}
.shelf-dialog-footer {
  padding: 10px 15px;
  border-top: 1px solid #ebebeb;
  font-size: 12px;
}
</style>